<!--
  Wrap an <img> (or a vue component that renders an <img>) with this component
  and get soft fade in when the image finishes loading.

  Make sure the image either has explicit intrinsic size set on it (width, height)
  or aspect-ratio set to get the effect.
-->

<template>
  <slot />
</template>

<script setup>
import { getCurrentInstance, onMounted } from 'vue';

const instance = getCurrentInstance();

function handleImageLoaded(ev) {
  const imgNode = ev.currentTarget;
  imgNode?.classList.remove('o-0');
}

onMounted(() => {
  const imgChildNode = instance.subTree?.children?.[0]?.el;
  if (imgChildNode instanceof HTMLImageElement) {
    imgChildNode.classList.add('o-0');
    imgChildNode.addEventListener('load', handleImageLoaded);
  }
});
</script>

<style scoped>
:slotted(img) {
  transition: opacity 0.15s;
}
</style>
